export default "__VITE_ASSET__39bce8e1__"